export default "__VITE_ASSET__b5d43891__"